import { InternalTransferUpdatePage } from '@/features/internal-transfer/pages/InternalTransferUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/internal-transfer/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["internal_transfer.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InternalTransferUpdatePage,
})
